import Api from '@sv-support-sdk/chat-api';

import { toCamelCaseRecursive } from '@sv-support-sdk/utils/src/helpers/string';

import { fetchAuthToken } from './tokens';
import { API_URL, SUPPORT_BACKEND_API } from '../config';

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
};

const api = new Api({
  baseURL: API_URL,
  headers,
});

const supportBackendApi = new Api({
  baseURL: SUPPORT_BACKEND_API,
  headers,
});

const apiInstance = api.setupInstance();

const supportBackendInstance = supportBackendApi.setupInstance({
  interceptors: {
    request: {
      onFullfilled: (config) => {
        const token = fetchAuthToken();

        config.headers.Authorization = token ? `Bearer ${token}` : null;

        return config;
      },
    },
    response: {
      onFullfilled: (response) => {
        return toCamelCaseRecursive(response.data);
      },
      onRejected: (error) => {
        return Promise.reject(error);
      },
    },
  }
});

export { supportBackendInstance };

export default apiInstance;
